
import React, { useState, useEffect } from 'react'
import { Checkdevice } from '../../../../components'
import { CLEARSTYLE } from '../../../../config/cssconstants'
import './VendorsFilterAndSortModalContent.css'

function VendorsFilterAndSortModalContent(props) {

    const [availablefilters, setAvailablefilters] = useState({})
    const [active, setActive] = useState(false)
    const [titles, setTitles] = useState([])
    const [headerbools, setHeaderbools] = useState([])
    const [headernames, setHeadernames] = useState([])

    const device = Checkdevice()

    useEffect(() => {
        const { availablefilters, filtersetting, selectedVendorType, usertype, sortorfilter } = props

        const { Keys, active } = availablefilters[selectedVendorType]
        var headers = []
        var key_ut_vt = usertype + selectedVendorType
        if (key_ut_vt in filtersetting) {
            headers = filtersetting[key_ut_vt]
        }

        // var headerbools = []
        // var headernames = []

        // if (sortorfilter === 'SORT') {
        //     for (let i = 0; i < Keys.length; i++) {

        //         if (Keys[i] === 'Sort') {

        //             for (let k = 0; k < availablefilters[selectedVendorType]['Sort'].length; k++) { // check if user got any of the SORT option selected
        //                 headerbools.push(false)
        //                 headernames.push(availablefilters[selectedVendorType]['Sort'][k].header)
        //             }

        //             for (let k = 0; k < availablefilters[selectedVendorType]['Sort'].length; k++) { // check if user got any of the SORT option selected
        //                 for (let j = 0; j < filtersetting['Wedding' + selectedVendorType].length; j++) {

        //                     if (availablefilters[selectedVendorType]['Sort'][k].header === filtersetting['Wedding' + selectedVendorType][j]) {
        //                         headerbools[k] = true
        //                     }
        //                 }
        //             }
        //             break

        //         }
        //         else {
        //             continue
        //         }
        //     }

        // }
        // else if (sortorfilter === 'FILTER') {
        //     let New_Keys = Keys.slice()
        //     New_Keys.splice(New_Keys.indexOf('Sort'), 1)
        //     for (let i = 0; i < New_Keys.length; i++) {
        //         const key = New_Keys[i]
        //         for (let k = 0; k < availablefilters[selectedVendorType][key].length; k++) { // check if user got any of the SORT option selected
        //             headerbools.push(false)
        //             headernames.push(availablefilters[selectedVendorType][key][k].header)
        //         }

        //         for (let k = 0; k < availablefilters[selectedVendorType][key].length; k++) { // check if user got any of the SORT option selected
        //             for (let j = 0; j < filtersetting['Wedding' + selectedVendorType].length; j++) {

        //                 if (availablefilters[selectedVendorType][key][k].header === filtersetting['Wedding' + selectedVendorType][j]) {
        //                     headerbools[k] = true
        //                 }

        //             }
        //         }

        //     }

        // }

        var headerbools = [] // store all the boolean state of tag
        var headernames = [] // store every single tags

        for (let i = 0; i < Keys.length; i++) {
            const key = Keys[i]
            for (let j = 0; j < availablefilters[selectedVendorType][key].length; j++) {
                const { header } = availablefilters[selectedVendorType][key][j]
                var checked = false
                if (headers.length > 0) {
                    for (let k = 0; k < headers.length; k++) {
                        if (headers[k] === header) { // check with user's filter if the header is already checked
                            checked = true
                        }
                    }
                }
                headerbools.push(checked)
                headernames.push(header)
            }
        }

        setHeaderbools([...headerbools])
        setHeadernames([...headernames])
        setTitles(Keys)
        setActive(active)
        setAvailablefilters(JSON.parse(JSON.stringify(availablefilters)))

    }, [])

    const applyClick = () => {
        // if you are in Sort, you will have to combine current selected filters with Filter selected filters
        // vice versa for Filter as well.
        const { availablefilters, filtersetting, selectedVendorType, sortorfilter } = props
        const { Keys, active } = availablefilters[selectedVendorType]
        
        let result = []
        for(let i=0;i< headerbools.length;i++){
            if(headerbools[i]){
                result.push(headernames[i])
            }   
        }

        props.onApplyFilter(result)

    }

    const runType0 = (k) => { // with one or more selection
        let local_filterarr = headerbools.slice()
        local_filterarr[k] = !local_filterarr[k]
        setHeaderbools([...local_filterarr])
    }

    const runType1 = (item, boolindex, title) => { // with one selection
        let allheaderbools = headerbools.slice()
        for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
            const { header } = availablefilters[props.selectedVendorType][title][i]
            if (header !== item[boolindex].header) {
                const allheaderbool_index = headernames.indexOf(header)
                allheaderbools[allheaderbool_index] = false
            }

        }
        allheaderbools[boolindex] = !allheaderbools[boolindex]
        setHeaderbools([...allheaderbools])
    }

    const checkboxesContent = () => {
        const { selectedVendorType } = props
        var root = []

        if (props.sortorfilter === 'SORT') {
            const i = 0
            const title = titles[i]

            const catarr = availablefilters[selectedVendorType][title]
            var checkboxarr = []
            for (let j = 0, k = 0; j < catarr.length; j++, k++) {
                const _k = k
                const { type, header } = catarr[j]
                const cbclicked = () => type === 0 ? runType0(_k) : runType1(catarr, _k, title)
                checkboxarr.push(
                    <div key={j + title + k} className="FMC_cbrow" onClick={cbclicked}>
                        {/* <input className="FMC_cb" type="checkbox" checked={headerbools[_k] ? headerbools[_k] : false} onClick={(e) => e.stopPropagation()}/> */}
                        <input
                            className="FMC_cb"
                            type="checkbox"
                            checked={headerbools[_k] ? headerbools[_k] : false}
                            onClick={cbclicked}
                            readOnly
                        />
                        <label className="FMC_cblbl">{header}</label>
                    </div>
                )
            }

            const reset = () => {
                var local_filterarr = headerbools.slice()
                for (let i = 0; i < catarr.length; i++) {// obtain the indexes to be cleared from (1d array)
                    const { header } = catarr[i]
                    var index = headernames.indexOf(header)
                    for (let j = 0; j < headernames.length; j++) {
                        if (headernames[j] === header) {
                            local_filterarr[index] = false
                        }
                    }
                }
                setHeaderbools([...local_filterarr])
            }

            root.push(
                <div key={title + i} className="FMC_mainbox" >
                    {/* <div className="FMC_TITLE">{title}</div> */}
                    <div className="FMC_BOX" >
                        <div className="FMC_RESETBTNBOX">
                            <button style={CLEARSTYLE} key={'clear' + i} onClick={reset}>Reset</button>
                        </div>
                        {checkboxarr}
                    </div>
                </div>
            )

        }
        else if (props.sortorfilter === 'FILTER') {
            for (let i = 1, k = 0; i < titles.length; i++) {
                const title = titles[i]

                const catarr = availablefilters[selectedVendorType][title]
                var checkboxarr = []
                for (let j = 0; j < catarr.length; j++, k++) {
                    const _k = k
                    const { type, header } = catarr[j]
                    const cbclicked = () => type === 0 ? runType0(_k) : runType1(catarr, _k, title)
                    checkboxarr.push(
                        <div key={j + title + k} className="FMC_cbrow" onClick={cbclicked}>
                            {/* <input className="FMC_cb" type="checkbox" checked={headerbools[_k] ? headerbools[_k] : false} onClick={(e) => e.stopPropagation()}/> */}
                            <input
                                className="FMC_cb"
                                type="checkbox"
                                checked={headerbools[_k] ? headerbools[_k] : false}
                                onClick={(e) => e.stopPropagation()}
                                readOnly
                            />
                            <label className="FMC_cblbl">{header}</label>
                        </div>
                    )
                }

                const reset = () => {
                    var new_headerbools = headerbools.slice()
                    for (let i = 0; i < catarr.length; i++) {// obtain the indexes to be cleared from (1d array)
                        const { header } = catarr[i]
                        for (let j = 0; j < headernames.length; j++) {
                            console.log(headernames[j] + ' _ ' + header)
                            if (headernames[j] === header) {
                                new_headerbools[j] = false
                            }
                        }
                    }
                    console.log('new_headerbools', new_headerbools)
                    setHeaderbools([...new_headerbools])
                }

                root.push(
                    <div key={title + i} className="FMC_mainbox" >
                        <div className="FMC_TITLE">{title}</div>
                        <div className="FMC_BOX" >
                            <div className="FMC_RESETBTNBOX">
                                <button style={CLEARSTYLE} key={'clear' + i} onClick={reset}>Reset</button>
                            </div>
                            {checkboxarr}
                        </div>
                    </div>
                )

            }
        }

        return root
    }

    const checkboxescontent = titles.map((title, titleindex) => {

        if (props.sortorfilter === 'SORT' && title === 'Sort') {
            return <div key={title + titleindex} className="FMC_mainbox" >
                <div className="FMC_TITLE">{title}</div>
                <div className="FMC_BOX" >
                    <div className="FMC_RESETBTNBOX">
                        <button
                            key={'clear' + titleindex}
                            style={CLEARSTYLE}
                            onClick={() => {
                                let allheaderbools = headerbools.slice()
                                for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                    const { header } = availablefilters[props.selectedVendorType][title][i]
                                    const allheaderbool_index = headernames.indexOf(header)
                                    allheaderbools[allheaderbool_index] = false
                                }
                                setHeaderbools([...allheaderbools])
                            }}
                        >
                            Reset
                        </button>
                    </div>
                    {availablefilters[props.selectedVendorType][title].map((item, itemindex) => {
                        const { header, type } = item
                        const boolindex = headernames.indexOf(header)

                        return <div
                            key={titleindex + title + itemindex}
                            className="FMC_cbrow"
                            onClick={() => {
                                if (type === 0) {
                                    let allheaderbools = headerbools.slice()
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])

                                }
                                else if (type === 1) {
                                    let allheaderbools = headerbools.slice()
                                    for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                        const { header } = availablefilters[props.selectedVendorType][title][i]
                                        if (header !== item.header) {
                                            const allheaderbool_index = headernames.indexOf(header)
                                            allheaderbools[allheaderbool_index] = false
                                        }

                                    }
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])
                                }
                            }}
                        >
                            <input
                                className="FMC_cb"
                                type="checkbox"
                                checked={headerbools[boolindex]}
                                onChange={() => {
                                    if (type === 0) {
                                        let allheaderbools = headerbools.slice()
                                        allheaderbools[boolindex] = !allheaderbools[boolindex]
                                        setHeaderbools([...allheaderbools])

                                    }
                                    else if (type === 1) {
                                        let allheaderbools = headerbools.slice()
                                        for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                            const { header } = availablefilters[props.selectedVendorType][title][i]
                                            if (header !== item.header) {
                                                const allheaderbool_index = headernames.indexOf(header)
                                                allheaderbools[allheaderbool_index] = false
                                            }

                                        }
                                        allheaderbools[boolindex] = !allheaderbools[boolindex]
                                        setHeaderbools([...allheaderbools])
                                    }
                                }}
                            />
                            <label className="FMC_cblbl">{header}</label>
                        </div>
                    })}
                </div>
            </div>
        }

        else if (props.sortorfilter === 'FILTER' && title !== 'Sort') {
            return <div key={title + titleindex} className="FMC_mainbox" >
                <div className="FMC_TITLE">{title}</div>
                <div className="FMC_BOX" >
                    <div className="FMC_RESETBTNBOX">
                        <button
                            key={'clear' + titleindex}
                            style={CLEARSTYLE}
                            onClick={() => {
                                let allheaderbools = headerbools.slice()
                                for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                    const { header } = availablefilters[props.selectedVendorType][title][i]
                                    const allheaderbool_index = headernames.indexOf(header)
                                    allheaderbools[allheaderbool_index] = false
                                }
                                setHeaderbools([...allheaderbools])
                            }}
                        >
                            Reset
                        </button>
                    </div>
                    {availablefilters[props.selectedVendorType][title].map((item, itemindex) => {
                        const { header, type } = item
                        const boolindex = headernames.indexOf(header)

                        return <div
                            key={titleindex + title + itemindex}
                            className="FMC_cbrow"
                            onClick={() => {
                                if (type === 0) {
                                    let allheaderbools = headerbools.slice()
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])

                                }
                                else if (type === 1) {
                                    let allheaderbools = headerbools.slice()
                                    for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                        const { header } = availablefilters[props.selectedVendorType][title][i]
                                        if (header !== item.header) {
                                            const allheaderbool_index = headernames.indexOf(header)
                                            allheaderbools[allheaderbool_index] = false
                                        }

                                    }
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])
                                }
                            }}
                        >
                            <input
                                className="FMC_cb"
                                type="checkbox"
                                checked={headerbools[boolindex]}
                                onChange={() => {
                                    if (type === 0) {
                                        let allheaderbools = headerbools.slice()
                                        allheaderbools[boolindex] = !allheaderbools[boolindex]
                                        setHeaderbools([...allheaderbools])

                                    }
                                    else if (type === 1) {
                                        let allheaderbools = headerbools.slice()
                                        for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                            const { header } = availablefilters[props.selectedVendorType][title][i]
                                            if (header !== item.header) {
                                                const allheaderbool_index = headernames.indexOf(header)
                                                allheaderbools[allheaderbool_index] = false
                                            }

                                        }
                                        allheaderbools[boolindex] = !allheaderbools[boolindex]
                                        setHeaderbools([...allheaderbools])
                                    }
                                }}
                            />
                            <label className="FMC_cblbl">{header}</label>
                        </div>
                    })}
                </div>
            </div>
        }


    })


    return active
        ? <div className={"FMC_ROOT" + device} style={{ placeContent: 'space-between' }}>
            {/* <div>
                {checkboxesContent()}
            </div> */}
            {checkboxescontent}

            {device === 'MOBILE'
                ? <div className="FMC_APPLYBTNBOX">
                    <button
                        className='Rsvpexplorer_portalsave'
                        style={{
                            position: 'relative',
                            bottom: 0,
                            backgroundColor: '#ffffff',
                            color: 'var(--maindark)',
                            border: '1px solid var(--maindark)',
                            minHeight: 45,
                            width: '100%',
                            margin: 0
                        }}
                        onClick={applyClick}
                    >
                        Apply
                    </button>
                </div>
                : <div className="FMC_APPLYBTNBOX">
                    <button
                        className='Rsvpexplorer_portalsave'
                        style={{
                            position: 'relative',
                            bottom: 0,
                            backgroundColor: '#ffffff',
                            color: 'var(--maindark)',
                            border: '1px solid var(--maindark)',
                            minHeight: 45,
                            width: '100%',
                            margin: 0
                        }}
                        onClick={applyClick}
                    >
                        Apply
                    </button>
                </div>}

        </div>
        : <div className="FMC_EMPTYROOT">
            <div className="FMC_EMPTYDIV" />
            <h4>Empty</h4>
            <div className="FMC_EMPTYDIV" />
        </div>
}
export default VendorsFilterAndSortModalContent